import { profileClient } from "@/shared/api/clients";

export interface FeatureFlag {
  slug: string;
  name: string;
  description?: string;
  enabled: boolean;
}

export interface ListFeatureFlagsResponse {
  flags: FeatureFlag[];
  total: number;
}

export interface ToggleFeatureFlagResponse {
  slug: string;
  enabled: boolean;
}

export const getFeatureFlags = async (stationId: string): Promise<ListFeatureFlagsResponse> => {
  const response = await profileClient.get<ListFeatureFlagsResponse>(`/v1/stations/${encodeURIComponent(stationId)}/feature-flags`);
  return response.data;
};

export const toggleFeatureFlag = async (stationId: string, slug: string, enabled: boolean): Promise<ToggleFeatureFlagResponse> => {
  const response = await profileClient.put<ToggleFeatureFlagResponse>(`/v1/stations/${encodeURIComponent(stationId)}/feature-flags`, {
    slug,
    enabled,
  });
  return response.data;
};
